import { render, staticRenderFns } from "./modal-content.vue?vue&type=template&id=1614d6c4&"
import script from "./modal-content.vue?vue&type=script&lang=ts&"
export * from "./modal-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports